export enum EAircraftStatusType {
  OnGround = 'OnGround',
  OnFly = 'OnFly',
  OnMaintenance = 'OnMaintenance',
}
